import { useQuery } from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import { TopicManagementList } from 'models/topic.model';

import API from '../../services/api';

import topicKeys from './_queryKeys';

const getTopics = async () => {
    const { data } = await API.topicManagementList();
    return data;
};

export default function useAllTopicQuery() {
    return useQuery<TopicManagementList[], BaseError>({
        queryKey: topicKeys.all(),
        queryFn: () => getTopics(),
        staleTime: 1000 * 60 * 60,
    });
}
